import React from 'react'
import RequireAuth from '@Components/Utility/RequireAuth'
import NewUserScene from '@Scenes/NewUserScene'
import { NEW_USER_ROUTE } from '@App/navigation/route'

const createNewUserRoutes = () => ({
    path: NEW_USER_ROUTE,
    element: (
        <RequireAuth>
            <NewUserScene />
        </RequireAuth>
    ),
})
export default createNewUserRoutes
